import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-9"
}
const _hoisted_9 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-9"
}
const _hoisted_10 = {
  key: 0,
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-9"
}
const _hoisted_11 = {
  key: 1,
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-9"
}
const _hoisted_12 = { class: "menu-item px-5" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Mi Perfil ")
const _hoisted_14 = { class: "menu-item px-5 my-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Cambiar Contraseña ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_17 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Logo",
            class: "rounded-circle",
            src: _ctx.imagen
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.username), 1),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.email), 1),
          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.rol.toUpperCase()), 1),
          (_ctx.rol !== 'supervisor' && _ctx.rol !== 'consultas departamentales')
            ? (_openBlock(), _createElementBlock("a", _hoisted_10, _toDisplayString(_ctx.nombre_recinto_penitenciario) + " - " + _toDisplayString(_ctx.departamento_centro_penitenciario), 1))
            : (_openBlock(), _createElementBlock("a", _hoisted_11, _toDisplayString(_ctx.departamento_supervisar), 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        to: { name: 'myProfile' },
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_router_link, {
        to: { name: 'myPassword' },
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onLogout())),
        class: "menu-link px-5"
      }, " Salir ")
    ])
  ]))
}